import { Modal } from 'flowbite-react';
import { FormikProvider, useFormik } from 'formik';
import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';

import FormActivateRenter from '../forms/FormActivateRenter';
import VelotrackActivate from './fields/UploadInfoApis/VelotrackActivate';
import AssasActivate from './fields/UploadInfoApis/AssasActivate';
import ZapSignActivate from './fields/UploadInfoApis/ZapSignActivate';
import "./ApproveRenter.scss"
import { useEffect, useMemo, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import ZapSignConfirmation from './fields/UploadInfoApis/ZapSignConfirmation';
import { createContract } from '../../services/integration.api';
import { saveVehicleRecords } from '../../../../common/services/vehicles.api';
import { approveRenter } from '../../../../common/services/renters.api';
import { SignatureInfo } from '../../../../types/renter.type';
import VerifyTrackerVelotrack from './fields/UploadInfoApis/VerifyTrackerVelotrack';
import KmMottors from './fields/Odometter';

export type Props = {
  renter: { _id: string, name: string }
  onClose: () => void
  idCompanyB2B?: string
  allowedPlates?: string[] | null;
}

export default function ModalApproveRenter(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()
  const [isApproved, setIsApproved] = useState(false);
  const [submitResult, setSubmitResult] = useState<string | null>(null);
  const [signatureInfo, setSignatureInfo] = useState<SignatureInfo>()
  const [trackerVerified, setTrackerVerified] = useState(false)
  const [photosDelivery, setPhotosDelivery] = useState(false);
  const [realCondutorVerified, setRealCondutorVerified] = useState(false)

  const today = new Date(); // Obtenha a data atual no formato YYYY-MM-DD
  const initialValues = {
    renterId: props.renter._id,
    renterName: props.renter.name,
    vehicle: {
      _id: "",
      licensePlate: "",
      odometerLocavibe: "",
      brand: "",
      partnerInfo: {
        companyName: ""
      }
    },
    realCondutorVerified: false,
    odometerVehicle: "",

    period: {
      value: "",
      label: "",
      months: 0,
    },
    additions: [],
    valueDepositCredit: 0,
    creditDeposit: 0,
    deposit: 0,
    registers: [
      { type: 'Frente do veículo', content: '' },
      { type: 'Lateral direita do veículo', content: '' },
      { type: 'Lateral esquerda do veículo', content: '' },
      { type: 'Traseira do veículo', content: '' },
      { type: 'Odômetro', content: '' },
      { type: 'Foto com o cliente', content: '' },
      { type: 'Print do real condutor / aceite do real condutor', content: '' }
    ],
    subscriptionInitialDate: today,
    valueDepositInstallments: 0,
    installmentOption: "",
    methodPayment: "",
    easyDeposit: false,
    easyDepositDate: today,
    easyDepositEntryOption: "",
    easyDepositEntryValue: 0,
    easyDepositInstallments: 0,
    easyDepositInstallmentsValue: 0,
    easyDepositRemainingValue: 0
  }

  const formik = useFormik({
    initialValues,
    // validationSchema,
    onSubmit: async (data) => {

      const yourVibe = data.period.label.includes("SV");
      if (yourVibe) {
        // if (data.vehicle.brand == "HONDA") {
        //   notifyError("Veículo não elegível para o plano SUA VIBE")
        //   return
        // }
        // const vehicleElegibleYourVibe = data.vehicle.odometerLocavibe ? 1 : 0;
        // if (!vehicleElegibleYourVibe) {
        //   notifyError("Veículo não elegível para o plano SUA VIBE")
        //   return
        // }
      }


      const savePhotoDelivery = {
        renterId: data.renterId,
        vehicleId: data.vehicle._id,
        photos: data.registers,
        photosMaintenance: data.registers,
        nameRenter: data.renterName,
        licensePlate: data.vehicle.licensePlate,

      }

      const resultPhoto = await saveVehicleRecords(savePhotoDelivery)
      if (!resultPhoto.ok) {
        notifyError(resultPhoto.message as string)
        setSubmitResult('error');
        return
      }
      notifySuccess("Fotos salvas com sucesso");

      const activationData = {
        renterId: data.renterId,
        vehicleId: data.vehicle._id,
        creditDeposit: data.creditDeposit,
        valueDepositCredit: data.valueDepositCredit,
        period: data.period,
        additions: data.additions,
        deposit: data.deposit,
        subscriptionInitialDate: data.subscriptionInitialDate,
        installmentOption: data.installmentOption,
        easyDeposit: data.easyDeposit,
        easyDepositEntryValue: data.easyDepositEntryValue,
        easyDepositInstallments: data.easyDepositInstallments,
        easyDepositInstallmentsValue: data.easyDepositInstallmentsValue,
        easyDepositRemainingValue: data.easyDepositRemainingValue,
        odometerVehicle: data.odometerVehicle,
        realCondutorVerified: realCondutorVerified,
      }
      const result = await approveRenter(activationData)

      if (!result.ok) {
        notifyError(result.message as string)
        setSubmitResult('error');
        return
      }

      notifySuccess("Solicitação emitida, Aguardando pagamentos para concluir a ativação")
      setSubmitResult('success');

    }
  })


  const AGUIAS_COMPANY_NAME = "AGUIAS CONSULTORIA DE ATENDIMENTO LTDA";
  const isAguiasPartner = formik.values?.vehicle?.partnerInfo?.companyName?.match(/AGUIAS CONSULTORIA DE ATENDIMENTO LTDA/i) || formik.values?.vehicle?.partnerInfo?.companyName?.match(/AGUIAS CONSULTORIA/i);

  // useEffect para auto-verificação
  useEffect(() => {
    if (isAguiasPartner) {
      setTrackerVerified(true);
    } else {
      setTrackerVerified(false);
    }
  }, [isAguiasPartner]);


  const depositData = {
    renterId: formik.values.renterId,
    valueDepositInstallments: formik.values.valueDepositInstallments,
    methodPayment: formik.values.methodPayment,
    installmentOption: formik.values.installmentOption,
    deposit: formik.values.deposit,
    creditDeposit: formik.values.creditDeposit,
    valueDepositCredit: formik.values.valueDepositCredit,
    easyDeposit: formik.values.easyDeposit,
    easyDepositDate: formik.values.easyDeposit ? formik.values.easyDepositDate : null,
    easyDepositEntryOption: formik.values.easyDepositEntryOption,
    easyDepositEntryValue: formik.values.easyDepositEntryValue,
    easyDepositInstallments: formik.values.easyDepositInstallments,
    easyDepositRemainingValue: formik.values.easyDepositRemainingValue,
    odometerVehicle: formik.values.odometerVehicle,
  };


  const vehicle = formik.values.vehicle;

  // Atualizando o contractData com verificação de vehicle._id
  const contractData = {
    renterId: formik.values.renterId,
    vehicleId: vehicle && vehicle._id ? vehicle._id : "", // Checagem se vehicle existe
    period: formik.values.period,
    additions: formik.values.additions,
    odometerVehicle: formik.values.odometerVehicle,
  };

  const badgeColor = useMemo(() => {
    if (submitResult === "success") return "text-greenPrimary";
    if (submitResult === "error") return "text-redPrimary";
    return "text-gray";
  }, [submitResult]);

  useEffect(() => {
    if (formik.values.registers.every(register => register.content.includes("entrega"))) setPhotosDelivery(true);

    setIsApproved(submitResult === 'success')

  }, [submitResult, formik.values.registers]);

  function handleSignature(contractInfo) {
    setSignatureInfo(contractInfo)
  }



  return (
    <Modal
      size="4xl"
      show={true}
      onClose={() => props.onClose()}>
      <Modal.Header className='text-black'>
        <h2 className='text-black'>Aprovar {props.renter.name}</h2>
      </Modal.Header>
      <form onSubmit={formik.handleSubmit} className='overflow-auto h-full'>
        <FormikProvider value={formik}>
          <Modal.Body className='w-full relative border-gray flex flex-col text-black'
          >
            <FormActivateRenter
              idCompanyB2B={props.idCompanyB2B ?? null}
              allowedPlates={props.allowedPlates} />
            <div>
              {photosDelivery === false && (
                <p className="text-redPrimary text-[18px]">
                  Todas as fotos de entrega do veículo devem ser adicionadas nos registros.
                </p>
              )}
            </div>
            <div className='p-4 border border-gray-200 rounded-lg mb-4 bg-white'>
              <div className="flex items-center justify-between">
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={() => {
                    if (formik.values?.vehicle?._id) {
                      setRealCondutorVerified(!realCondutorVerified);
                    }
                  }}
                  style={{
                    opacity: formik.values?.vehicle?._id ? 1 : 0.5,
                    cursor: formik.values?.vehicle?._id ? 'pointer' : 'not-allowed'
                  }}
                >
                  <input
                    type="checkbox"
                    id="realcondutor-check"
                    checked={realCondutorVerified}
                    onChange={(e) => {
                      e.stopPropagation();
                      setRealCondutorVerified(e.target.checked);
                    }}
                    className="w-5 h-5 text-green-600 border-gray-300 rounded focus:ring-green-500 cursor-pointer"
                    disabled={!formik.values?.vehicle?._id}
                  />
                  <label
                    htmlFor="realcondutor-check"
                    className="text-sm font-semibold text-gray-700 select-none"
                  >
                    Confirmar que o real condutor foi realizado
                  </label>
                </div>
                {realCondutorVerified && (
                  <FaCheckCircle size={24} className="text-greenPrimary" />
                )}
              </div>
            </div>

            <KmMottors disabled={!realCondutorVerified} />

            <div className='grid-template'>
              {isAguiasPartner ? (
                <div className="p-0 grid-class">
                  <div>
                    <h2 className="font-semibold">Rastreador pré-aprovado</h2>
                  </div>
                  <div className="grid-div2">
                    <div className="flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
                      <FaCheckCircle size={16} className="text-green-600" />
                      <span className="text-green-700 text-sm font-medium">
                        Verificação automática para {AGUIAS_COMPANY_NAME}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <VerifyTrackerVelotrack
                  disabled={!formik.values?.vehicle?._id || !realCondutorVerified || !formik.values.odometerVehicle || Number(formik.values.odometerVehicle) <= 0}
                  onSuccessVerify={() => setTrackerVerified(true)}
                />
              )}

              <div className="p-0 grid-class">
                <div>
                  <h2 className="font-semibold ">Clique aqui para vincular o veículo no cliente:</h2>
                </div>
                <div className="grid-div2">
                  <ButtonWithLoader
                    isLoading={formik.isSubmitting}
                    disabled={
                      !(formik.values?.vehicle?._id) ||
                      !photosDelivery ||
                      !realCondutorVerified ||
                      !trackerVerified ||
                      !formik.values.odometerVehicle ||
                      Number(formik.values.odometerVehicle) <= 0
                    }
                    onClick={() => setIsApproved(true)}
                  >
                    Vincular
                  </ButtonWithLoader>
                  <FaCheckCircle size={24} className={`${badgeColor}`} />

                </div>
              </div>

              <VelotrackActivate
                disabled={!isApproved}
                onSave={function (): void {
                  throw new Error('Function not implemented.');
                }}
                renterId={formik.values.renterId} />
              <AssasActivate
                disabled={!isApproved}
                onSave={function (): void {
                  throw new Error('Function not implemented.');
                }} depositData={depositData} />
              {contractData.vehicleId && (
                <ZapSignActivate
                  disabled={!isApproved}
                  onSave={function (): void {
                    throw new Error('Function not implemented.');
                  }} contractData={contractData}
                  handleSignature={handleSignature}
                  contractFn={createContract} />
              )}
              {signatureInfo?.ok && (
                <ZapSignConfirmation
                  contractInfo={signatureInfo}
                />)}
            </div>
          </Modal.Body>
        </FormikProvider>
      </form>
      <Modal.Footer>
      </Modal.Footer>
    </Modal >
  );
}
